import React, { PureComponent, Fragment } from "react";
import PropTypes from "prop-types";
import moment from 'moment';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Table, Checkbox, Button, Drawer, Spin, Select, DatePicker } from "antd";
import InfiniteScroll from "react-infinite-scroll-component";
import MdExpandMore from "react-icons/lib/md/expand-more";
import MdExpandLess from "react-icons/lib/md/expand-less";
import findIndex from "lodash/findIndex";
import some from "lodash/some";
import isEmpty from "lodash/isEmpty";
import "./index.scss";

import { pageChanged } from "../../../../../data/redux/page_details/actions";
import * as queryActions from "../../../../../data/redux/query_details/actions";
import { getAllIntents } from '../../../../../data/redux/nlp_details/actions';

import { APP_PAGES } from "../../../../../data/config/constants";
import { uniqueId, log } from "../../../../../data/config/utils";

import CardContainer from "../../../components/cardcontainer";
import CustomHeader from "../../../../../components/customheader";
import CirclePacking from "./components/circlepacking";
import IntentForm from "./components/intentform";
import CustomPagination from "../../../../../components/custompagination";
import CardRowTableLoader from "../../../components/loaders/cardrowtable";
import WordCloud from "./components/wordcloud";

const { Option } = Select
const { RangePicker } = DatePicker;

const dropdown_options = [{ name: 'Top 100', value: 100 }, { name: 'Top 200', value: 200 }, { name: 'Top 500', value: 500 }]

class QueryAnalytics extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedDate: "",
      selectedDataValue: 10,
      activeCollapsePanelId: "",
      selectedWordCloudLimit: 100,
      selectedWordCloudIntent: 'All',
      excludedWords: [],
      selectedRowData: [],
      selectedWordCloudDateRange: [moment(new Date("October 29, 2020"), "YYYY/MM/DD"), moment(new Date(), "YYYY/MM/DD")],
      search_key: '',
      drawerData: {
        title: "Title",
        show_create_new_intent_form: false,
        show_enhance_existing_intent_form: false
      }
    };
    this.columns = this.getIntentTableColumns();
  }

  componentDidMount() {
    const { actions } = this.props;
    const { excludedWords, selectedWordCloudLimit, selectedWordCloudIntent, selectedWordCloudDateRange } = this.state;
    actions.pageChanged(APP_PAGES.QUERY_ANALYTICS, APP_PAGES.ANALYTICS);
    actions.getAllIntents();
    actions.getDateFilter(() => {
      const latestDateKey = this.props.query_details.available_dates.slice(-1)[0];
      this.handleQueryAnalyticsDateChange(latestDateKey.value);
      const payload = {
        startDate: selectedWordCloudDateRange[0],
        endDate: selectedWordCloudDateRange[1],
        limit: selectedWordCloudLimit,
        exluded_words: excludedWords,
        intent: selectedWordCloudIntent
      }
      actions.getWordCloudData(payload)
    });
  }

  handleDiagramDataDropdownChange = limit => {
    const { actions } = this.props;
    this.setState({ selectedDataValue: limit });
    actions.getClusterData({
      dateKey: `${this.state.selectedDate}`,
      limit: limit
    });
  };

  handleChangeCheckbox = rowData => {
    const { selectedRowData } = this.state;
    if (some(selectedRowData, ["id", rowData.id])) {
      let foundIndex = findIndex(selectedRowData, { id: rowData.id });
      let newselectedRowData = [...selectedRowData];
      newselectedRowData.splice(foundIndex, 1);
      this.setState({ selectedRowData: newselectedRowData });
    } else {
      this.setState({ selectedRowData: [...selectedRowData, rowData] });
    }
  };

  onChangeIntentsTablePagination = current => {
    if (current) {
      const { actions, query_details } = this.props;
      const { selectedDate, search_key } = this.state;
      const payload = {
        ...query_details.clusters_table_filters,
        skip: (current - 1) * query_details.clusters_table_filters.limit,
        dateKey: `${selectedDate}`,
        search_key
      };
      actions.fetchTableData(payload, () =>
        actions.updateClustersState(current)
      );
    }
  };

  getIntentTableColumns = () => {
    const columns = [
      {
        title: "Group",
        key: "group",
        dataIndex: "group"
      },
      {
        title: "Intents",
        key: "intent",
        dataIndex: "intent",
        render: (text, record) => this.renderUtterances(record)
      },
      {
        title: "Size",
        key: "size",
        dataIndex: "total_cluster_size_unique"
      },
      {
        title: "Action",
        key: "action",
        dataIndex: "action",
        render: (text, record) => {
          const { id, intent } = record;
          const data = {
            id: id,
            intentName: intent
          };
          return (
            <Checkbox
              key={id}
              checked={
                some(this.state.selectedRowData, ["id", id]) ? true : false
              }
              onChange={() => this.handleChangeCheckbox(data)}
            />
          );
        }
      }
    ];
    return columns;
  };

  handleOpenNewIntentDrawer = () => {
    this.setState({
      drawerData: {
        title: "Create New Intent",
        show_create_new_intent_form: true
      }
    });
  };

  handleExistingIntentDrawer = () => {
    this.setState({
      drawerData: {
        title: "Enhance Existing Intents",
        show_enhance_existing_intent_form: true
      }
    });
  };

  handleCloseDrawer = () => {
    this.setState({
      drawerData: {
        show_create_new_intent_form: false,
        show_enhance_existing_intent_form: false
      }
    });
  };

  handleQueryAnalyticsDateChange = date => {
    const { actions } = this.props;
    const payload = {
      dateKey: `${date}`,
      limit: 10,
      skip: 0,
    };
    this.setState({ selectedDate: date });
    actions.getClusterData({ dateKey: `${date}`, limit: 10 });
    actions.fetchTableData(payload);
  };

  returnDropdownDates = () => {
    const { available_dates } = this.props.query_details;
    const dropdown_options = available_dates.map(date => ({
      name: date.label,
      value: date.value
    }));
    return dropdown_options;
  };

  returnWidth = () => {
    const { screen_width } = this.props.page_details.device_data;
    let drawerWidth;
    if (screen_width < 480) {
      drawerWidth = screen_width;
    } else if (screen_width >= 480 && screen_width <= 768) {
      drawerWidth = 512;
    } else {
      drawerWidth = 600;
    }
    return drawerWidth;
  };

  onClickIntent = id => {
    const { actions } = this.props;
    let payload = {
      id: id,
      limit: 20,
      skip: 0
    };
    if (this.state.activePanelId !== id) {
      actions.getUtterances(payload, () =>
        this.setState({ activePanelId: id })
      );
    } else {
      this.setState({ activePanelId: "" });
    }
  };

  loadMoreUtterances = () => {
    const { actions, query_details } = this.props;
    const { activePanelId } = this.state;
    if (activePanelId) {
      var filtered_utterance_data = query_details.utterance_data.find(
        data => activePanelId === data.id
      );
    }
    let payload = {
      id: filtered_utterance_data.id,
      limit: 20,
      skip: filtered_utterance_data.utterances.length
    };
    actions.loadMoreUtterances(payload);
  };

  filterOption = (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0

  onChangeWordCloudDropdown = selectedWordCloudLimit => {
    const { excludedWords, selectedWordCloudIntent, selectedWordCloudDateRange } = this.state;
    const payload = {
      startDate: selectedWordCloudDateRange[0],
      endDate: selectedWordCloudDateRange[1],
      limit: selectedWordCloudLimit,
      exluded_words: excludedWords,
      intent: selectedWordCloudIntent
    }
    this.props.actions.getWordCloudData(payload, () => {
      this.setState({ selectedWordCloudLimit })
    })
  }

  onChangeWordCloudIntentDropdown = intent => {
    const { excludedWords, selectedWordCloudLimit, selectedWordCloudDateRange } = this.state;
    const payload = {
      startDate: selectedWordCloudDateRange[0],
      endDate: selectedWordCloudDateRange[1],
      limit: selectedWordCloudLimit,
      exluded_words: excludedWords,
      intent
    }
    this.props.actions.getWordCloudData(payload, () => {
      this.setState({ selectedWordCloudIntent: intent })
    })
  }

  onChangeWordCloudDateRange = date_range => {
    const { excludedWords, selectedWordCloudLimit, selectedWordCloudIntent } = this.state;
    const payload = {
      startDate: date_range[0],
      endDate: date_range[1],
      limit: selectedWordCloudLimit,
      exluded_words: excludedWords,
      intent: selectedWordCloudIntent
    }
    this.props.actions.getWordCloudData(payload, () => {
      this.setState({ selectedWordCloudDateRange: date_range })
    })
  }

  handleCustomSelectApply = () => {
    const { selectedWordCloudDateRange, selectedWordCloudLimit, selectedWordCloudIntent, excludedWords } = this.state;
    const payload = {
      startDate: selectedWordCloudDateRange[0],
      endDate: selectedWordCloudDateRange[1],
      limit: selectedWordCloudLimit,
      exluded_words: excludedWords,
      intent: selectedWordCloudIntent
    }
    this.props.actions.getWordCloudData(payload)
  }

  handleExcludeWordsChange = excludedWords => {
    this.setState({ excludedWords })
  }

  onSearchIntents = search_key => {
    const { actions } = this.props;
    const payload = {
      dateKey: `${this.state.selectedDate}`,
      limit: 10,
      skip: 0,
      search_key
    }
    actions.fetchTableData(payload, () => {
      this.setState({ search_key })
    })
  }

  renderUtterances = data => {
    const { id, intent } = data;
    const { activePanelId } = this.state;
    const { utterance_data } = this.props.query_details;
    if (activePanelId) {
      var filtered_utterance_data = utterance_data.find(
        data => activePanelId === data.id
      );
    }
    return (
      <div className="ori-flex-column ori-flex-ac">
        <div
          className="ori-font-bold ori-hover-pointer"
          onClick={() => this.onClickIntent(id)}
        >
          {activePanelId === id ? (
            <MdExpandLess className="ori-r-mrgn-5" size={20} />
          ) : (
              <MdExpandMore className="ori-r-mrgn-5" size={20} />
            )}
          <span>{intent}</span>
        </div>
        {activePanelId === id ? (
          <div
            id={`panel-${id}`}
            className="ori-panel-custom ori-overflow-y-auto "
          >
            <InfiniteScroll
              key={id}
              scrollableTarget={`panel-${id}`}
              dataLength={filtered_utterance_data.utterances.length}
              hasMore={filtered_utterance_data.hasMore}
              style={{ overflow: "hidden" }}
              scrollThreshold={0.9}
              loader={<Spin size="small" />}
              next={this.loadMoreUtterances}
            >
              {
                <ol>
                  {
                    filtered_utterance_data.utterances.map((utterance, index) => (
                      <li
                        key={index}
                        className="ori-t-pad-5 ori-word-break ori-ws-break-spaces"
                      >
                        {utterance}
                      </li>
                    ))
                  }
                </ol>
              }
            </InfiniteScroll>
          </div>
        ) : null}
      </div>
    );
  };

  renderCirclePackingChart = () => {
    const { selectedDate, selectedDataValue } = this.state;
    const { cluster_data, loaders } = this.props.query_details;
    const custom_header_props = {
      title: "New Query Analysis",
      show_dropdown: selectedDate ? true : false,
      dropdown_value: selectedDataValue
        ? selectedDataValue
        : "Select number of groups to display",
      dropdown_options: [
        { name: "Top 10 groups", value: 10 },
        { name: "Top 20 groups", value: 20 },
        { name: "Top 50 groups", value: 50 },
        { name: "Top 100 groups", value: 100 },
        { name: "Top 200 groups", value: 200 },
        { name: "All groups", value: 1000 }
      ],
      onChangeDropdown: this.handleDiagramDataDropdownChange
    };
    return (
      <CardContainer
        custom_header_props={custom_header_props}
        load_error={loaders.cluster_data_load_error}
        loading={loaders.cluster_data_loading}
        emtpy_condition={isEmpty(cluster_data)}
        empty_msg="Please select a date range to proceed"
        show_custom_header
      >
        <div className="ori-flex ori-flex-jc ori-relative">
          <CirclePacking root={cluster_data} />
        </div>
      </CardContainer>
    );
  };

  renderWordCloud = () => {
    const { query_details, nlp_details } = this.props;
    const { selectedWordCloudLimit, excludedWords, selectedWordCloudIntent, selectedWordCloudDateRange } = this.state;
    return (
      <CardContainer
        load_error={query_details.word_cloud_data_load_error}
        loading={query_details.word_cloud_data_loading}
        emtpy_condition={query_details.word_cloud.length === 0}
        container_height={500}
        empty_msg='No data available for the selected date range'
      >
        <div className="ori-t-pad-15 ori-b-pad-5 ori-b-mrgn-10  ori-flex-row ori-flex-jsb ori-flex-wrap">
          Word Cloud
          <div className="ori-flex-row ori-flex-wrap">
            <RangePicker
              size="small"
              allowClear={false}
              className="ori-range-picker-default"
              format="DD-MM-YYYY"
              value={selectedWordCloudDateRange}
              placeholder={['Start date', 'End date']}
              disabled={query_details.word_cloud_data_loading}
              onChange={this.onChangeWordCloudDateRange}
            />

            <Select
              size="small"
              className="ori-select ori-font-xs ori-lr-pad-5"
              value={selectedWordCloudIntent}
              style={{ minWidth: "150px", maxWidth: "300px" }}
              disabled={query_details.word_cloud_data_loading}
              onChange={this.onChangeWordCloudIntentDropdown}
            >
              {[{ name: 'All' }, ...nlp_details.intents].map((option, index) => <Option key={index} value={option.name}>{option.name}</Option>)}
            </Select>
            <Select
              size="small"
              placeholder="Exclude words here"
              mode="multiple"
              style={{ minWidth: "150px", maxWidth: "300px" }}
              className="ori-r-mrgn-10"
              filterOption={this.filterOption}
              onChange={this.handleExcludeWordsChange}
            >
              {
                query_details.word_cloud.map((option, index) => <Option key={index} value={option.text}>{option.text}</Option>)
              }
            </Select>
            <Button
              size="small"
              type="primary"
              className="ori-lr-pad-5"
              disabled={excludedWords.length === 0}
              onClick={this.handleCustomSelectApply}
            >
              Exclude words
                    </Button>

            <Select
              size="small"
              className="ori-select ori-font-xs ori-lr-pad-5"
              value={selectedWordCloudLimit}
              disabled={query_details.word_cloud_data_loading}
              onChange={this.onChangeWordCloudDropdown}
            >
              {
                dropdown_options.map((item, index) => (<Option key={index} className="ori-font-xs" value={item.value}>{item.name}</Option>))
              }
            </Select>
          </div>
        </div>
        <WordCloud data={query_details.word_cloud} />
      </CardContainer>
    )
  }

  renderIntentsTable = () => {
    const { page_details, query_details } = this.props;
    const { utterance_data_loading } = this.props.query_details.loaders;
    const { selectedRowData } = this.state;
    const {
      show_create_new_intent_form,
      show_enhance_existing_intent_form
    } = this.state.drawerData;
    const mobile = page_details.device_data.screen_width < 768;

    if (
      query_details.loaders.table_data_loading &&
      query_details.table_data.length === 0
    )
      return <CardRowTableLoader />;

    return (
      <Fragment>
        {!(show_create_new_intent_form || show_enhance_existing_intent_form) &&
          utterance_data_loading ? (
            <Spin size="large">
              <Table
                className="ori-table-default ori-table-content-align-center ori-table-header-bg-transparent"
                columns={this.columns}
                rowKey={uniqueId}
                size={mobile ? "small" : "middle"}
                loading={query_details.loaders.table_data_loading}
                pagination={false}
                dataSource={query_details.table_data}
              />
              <CustomPagination
                size="small"
                current={query_details.table_pagination.current}
                next_disabled={!query_details.table_pagination.more_pages}
                onChange={this.onChangeIntentsTablePagination}
              />
            </Spin>
          ) : (
            <div>
              <Table
                className="ori-table-default ori-table-content-align-center ori-table-header-bg-transparent"
                columns={this.columns}
                rowKey={uniqueId}
                size={mobile ? "small" : "middle"}
                loading={query_details.loaders.table_data_loading}
                pagination={false}
                dataSource={query_details.table_data}
              />
              <CustomPagination
                size="small"
                current={query_details.table_pagination.current}
                next_disabled={!query_details.table_pagination.more_pages}
                onChange={this.onChangeIntentsTablePagination}
              />
            </div>
          )}
        <div className="ori-flex ori-flex-jc ori-t-mrgn-10">
          <Button
            type="primary"
            className="ori-r-mrgn-15"
            disabled={
              selectedRowData && selectedRowData.length > 0 ? false : true
            }
            onClick={this.handleOpenNewIntentDrawer}
          >
            Create New Intent
          </Button>
          <Button
            type="primary"
            className="ori-l-mrgn-15"
            // disabled={selectedRowData && selectedRowData.length > 0 ? false : true}    For future use
            disabled
            onClick={this.handleExistingIntentDrawer}
          >
            Enhance Existing Intents
          </Button>
        </div>
      </Fragment>
    );
  };

  renderIntentForm = () => {
    const { selectedRowData } = this.state;
    return (
      <IntentForm
        selectedIntents={selectedRowData}
        closeDrawer={this.handleCloseDrawer}
      />
    );
  };

  render() {
    const { selectedDate } = this.state;
    const {
      show_create_new_intent_form,
      show_enhance_existing_intent_form
    } = this.state.drawerData;
    const { loaders } = this.props.query_details;
    const custom_header_props = {
      title: "List Of Intents",
      show_search: true,
      search_placeholder: 'Search here',
      onSearch: this.onSearchIntents,
    };

    log("Query Analytics Rendering......");
    return (
      <div className="ori-lr-pad-10">
        <CustomHeader
          title="query analytics"
          dropdown_value={selectedDate ? selectedDate : "Select Date Range"}
          dropdown_options={this.returnDropdownDates()}
          right_wrapper_class="ori-r-pad-60"
          onChangeDropdown={this.handleQueryAnalyticsDateChange}
          bottom_bordered
          show_dropdown
        />
        {this.renderCirclePackingChart()}
        {this.renderWordCloud()}
        <CardContainer
          custom_header_props={custom_header_props}
          show_custom_header
          load_error={loaders.table_data_load_error}
        >
          {this.renderIntentsTable()}
        </CardContainer>
        <Drawer
          className="ori-drawer ori-drawer-title-primary ori-drawer-body-with-header ori-drawer-body-no-pad"
          width={this.returnWidth()}
          style={{
            height: "calc(100% - 60px)",
            overflow: "hidden",
            padding: "0px 0px 62px 0px"
          }}
          visible={
            show_create_new_intent_form || show_enhance_existing_intent_form
          }
          title={this.state.drawerData.title}
          placement="right"
          maskClosable={false}
          maskStyle={{ opacity: 1 }}
          onClose={this.handleCloseDrawer}
        >
          <div className="ori-full-parent-height ori-b-pad-65">
            {show_create_new_intent_form && this.renderIntentForm()}
          </div>
        </Drawer>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    page_details: state.page_details,
    query_details: state.query_details,
    nlp_details: state.nlp_details
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(
      Object.assign({}, { pageChanged, getAllIntents }, queryActions),
      dispatch
    )
  };
};

QueryAnalytics.propTypes = {
  actions: PropTypes.object,
  page_details: PropTypes.object,
  query_details: PropTypes.object,
  nlp_details: PropTypes.object
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QueryAnalytics);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/analytics/queryanalytics/index.js